/** Extensions opened as NullaPad “Excel” language (parsed to editable grid + JSON source). */
const EXCEL_VIEW_EXTENSIONS = new Set(["xlsx", "xlsm", "xls"]);

export function isExcelViewFile(file: File): boolean {
  const name = file.name.trim().toLowerCase();
  const dot = name.lastIndexOf(".");
  if (dot <= 0 || dot === name.length - 1) return false;
  return EXCEL_VIEW_EXTENSIONS.has(name.slice(dot + 1));
}
